<template>
  <div class="indexPage">
    <div class="banner">
      <img src="../../../assets/images/banner3.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon4"><i class="iconfont icon-yonghu"></i></div>
      <div class="breadcrumb_item">业务资源管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">客户物流管理</div>
    </div>

    <div class="customer_wrap">
      <div class="customer_list" v-if="dataList.length > 0">
        <div
          class="customer_item"
          v-for="(item, index) in dataList"
          :key="index"
          @click="handleGo(item.id)"
        >
          <div class="item">
            <div class="txt flex-rowl">
              <p class="label">姓名：</p>
              <p>{{ item.truename }}</p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">手机号：</p>
              <p>{{ item.mobile }}</p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">物流类型：</p>
              <p>
                {{
                  item.runtype == 1 ? "私人" : item.runtype == 2 ? "办公" : ""
                }}
              </p>
            </div>
          </div>

          <div class="item address">
            <div class="tit flex-rowl">
              <p class="label">所在地区：</p>
            </div>
            <div class="txt flex-rowl">
              <p>{{ item.provincestr }}</p>
              <p>{{ item.citystr }}</p>
              <p>{{ item.areastr }}</p>
            </div>
            <div class="txt">
              <p>
                {{ item.addr }}
              </p>
            </div>
          </div>
          <div class="item red">
            <div class="txt flex-rowl">
              <p class="label">是否默认：</p>
              <p>{{ item.isdefault }}</p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">是否启用：</p>
              <p>
                {{ item.isuse == 1 ? "启用" : item.isuse == 0 ? "停用" : "" }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <van-empty
        v-else-if="dataList.length == 0 && !loading"
        description="暂无数据"
      />
    </div>

    <div class="fixd_button_btm flex-rowl" v-if="isShowTabbar">
      <div class="item return" @click="handleReturn">返回</div>
      <div class="item" @click="handleGo(0)">新增物流信息</div>
    </div>
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../../api/api";
import { getCustomAddressList } from "../../../api/company";
import { mapState } from "vuex";
export default {
  name: "addressList",
  data() {
    return {
      isShowTabbar: true,
      id: "",
      customerGuid: "",
      loading: false,

      params: {
        ext_external_userid: "",
      },
      listTotal: 0,
      dataList: [],
      customerDetail: "", // 客户详情
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  mounted() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, customerGuid } = JSON.parse(res.jsondata);
        this.id = id;
        this.customerGuid = customerGuid;
        this.getCustomAddressList();
      } else {
        this.$router.back();
      }
    },

    // 获取数据
    getCustomAddressList() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getCustomAddressList({ guid: this.customerGuid }).then((res) => {
        this.dataList = res.list;
        Toast.clear();
      });
    },

    handleReturn() {
      history.back();
    },
    handleGo(id) {
      // this.$router.push(
      //   `/resourceIndex/addressDetail/${this.id}/${this.customerGuid}/${id}`
      // );
      this.encryptstringadd("addressDetail", {
        id: this.id,
        customerGuid: this.customerGuid,
        addressId: id,
      });
    },
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  box-sizing: border-box;
  padding-bottom: 190px;
  .screen_wrap {
    padding: 50px;
    font-size: 20px;
    color: #464646;
    .screen_list {
      .screen_item {
        flex-shrink: 0;
        height: 40px;
        line-height: 40px;
        min-width: 90px;
        max-width: 160px;
        padding: 0 10px 0 20px;
        border: 1px solid #d2d2d2;
        box-sizing: border-box;
        margin-right: 10px;
        .iconfont {
          margin-left: 10px;
        }
      }
      &:last-child {
        margin-top: 20px;
      }
      &.screen_list_one {
        .screen_item {
          width: 210px;
          &:first-child {
            width: 190px;
            max-width: 190px;
          }
        }
      }
    }
  }
  .input_wrap {
    padding: 0 45px 10px;
    box-sizing: border-box;
    .primary-button {
      width: 145px;
      margin-left: 20px;
      font-size: 26px;
    }
  }
  .customer_wrap {
    font-size: 22px;
    color: #3c3c3c;
    width: 650px;
    margin: 0 auto 30px;
    .red {
      color: #ff0036;
    }
    .customer_list {
      .customer_item {
        margin-bottom: 30px;
        border: 1px solid #d2d2d2;
        padding: 40px;
        box-sizing: border-box;
      }
      .item {
        margin-bottom: 45px;
        .txt {
          margin-bottom: 15px;
          align-items: flex-start;
          &:last-child {
            margin-bottom: 0;
          }
          .label {
            white-space: nowrap;
            width: 160px;
            flex-shrink: 0;
          }
          .label_list {
            .label_item {
              border: 1px solid #d2d2d2;
              padding: 5px 10px 5px 20px;
              margin-right: 10px;
            }
          }
        }
        &.address {
          .tit {
            margin-bottom: 10px;
          }
          .txt {
            font-size: 20px;
            p {
              &:nth-child(2) {
                margin: 0 30px;
              }
            }
          }
        }
        p {
          line-height: 28px;
        }
      }
    }
  }

  .custom_popup {
    z-index: 1000002 !important;
  }
}
</style>